import SquareRadioButton from "./square-radio-button";

export default SquareRadioButton;